import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelect from './LanguageSelect';
import './Header.css';

// 予約サイト左上のタイトル（管理画面「設定 > 基本設定」で変更。空なら既定のサイト名）
let siteTitleCache: Promise<string> | null = null;
export function loadSiteTitle(): Promise<string> {
  if (!siteTitleCache) {
    siteTitleCache = fetch('/api/site').then((r) => (r.ok ? r.json() : null)).then((d) => String(d?.site_title || '')).catch(() => '');
  }
  return siteTitleCache;
}

function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [siteTitle, setSiteTitle] = useState('');
  useEffect(() => { void loadSiteTitle().then(setSiteTitle); }, []);

  // ページ遷移時にメニューを閉じる
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // メニュー表示中は背景スクロールを止める
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const languageSelect = <LanguageSelect />;

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          {siteTitle || t('common.siteName')}
        </Link>

        <div className="header-actions">
          {languageSelect}
          <button
            type="button"
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            aria-label="Menu"
            aria-expanded={menuOpen}
            aria-controls="main-nav"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        <nav id="main-nav" className={`nav ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/" end className="nav-link">{t('header.booking')}</NavLink>
          <NavLink to="/booking" className="nav-link">{t('header.calendar')}</NavLink>
          <NavLink to="/mypage" className="nav-link">{t('header.mypage')}</NavLink>
        </nav>
      </div>
      {menuOpen && <div className="nav-backdrop" onClick={() => setMenuOpen(false)} />}
    </header>
  );
}

export default Header;
